"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTokenBalance = exports.compoundingLinearApproximation = exports.interestRateToApy = exports.deriveOvenAddress = void 0;
const lodash_1 = __importDefault(require("lodash"));
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const constants_1 = __importDefault(require("./constants"));
const decimal_js_1 = __importDefault(require("decimal.js"));
const deriveOvenAddress = async (operation) => {
    const ovenCreationResults = await operation.operationResults();
    const transactionResult = lodash_1.default.find(ovenCreationResults, (result) => {
        return result.kind === 'transaction';
    });
    const ovenResult = lodash_1.default.find(transactionResult.metadata.internal_operation_results, (operation) => {
        return operation.kind === 'origination';
    }).result;
    return ovenResult.originated_contracts[0];
};
exports.deriveOvenAddress = deriveOvenAddress;
const interestRateToApy = (interestRatePerPeriod) => {
    const currentValueNoMantissa = new bignumber_js_1.default(interestRatePerPeriod).dividedBy(new bignumber_js_1.default(10).pow(18));
    const currentValueDecimal = new decimal_js_1.default(currentValueNoMantissa.toFixed(18)).times(60 * 24 * 365);
    const E = new decimal_js_1.default('2.7182818284590452353602874713526624977572470936999595749669676277240766303535475945713821785251664274');
    const invertedLN = E.pow(currentValueDecimal);
    return invertedLN.minus(1).times(100);
};
exports.interestRateToApy = interestRateToApy;
const compoundingLinearApproximation = (initial, interestRatePerPeriod, numPeriods) => {
    return initial.times(constants_1.default.PRECISION.plus(interestRatePerPeriod.times(numPeriods))).div(constants_1.default.PRECISION);
};
exports.compoundingLinearApproximation = compoundingLinearApproximation;
const getTokenBalance = async (holder, tokenContractAddress, tezos, tokenContractStorage = undefined) => {
    const resolvedTokenStorage = tokenContractStorage !== null && tokenContractStorage !== void 0 ? tokenContractStorage : (await (await tezos.wallet.at(tokenContractAddress)).storage());
    const balance = await resolvedTokenStorage.balances.get(holder);
    return balance === undefined ? new bignumber_js_1.default(0) : balance.balance;
};
exports.getTokenBalance = getTokenBalance;
//# sourceMappingURL=utils.js.map